import React, {useEffect, useState} from 'react';
import {IonContent, IonModal, IonPage} from '@ionic/react';
import {useHistory} from 'react-router-dom';
import {TransformWrapper, TransformComponent} from 'react-zoom-pan-pinch';
import {ApiService} from "../api/ApiService";
import {DocumentInfo} from "../api/model/DocumentsList";
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { ChevronLeft, ChevronRight, DocIcon, FolderDocIcon } from '../components/icons';
import { useLogPageVisit } from '../utils/logPageVisit';
import { logUserAction } from '../utils/logUserAction';

const Permits: React.FC = () => {
    useLogPageVisit('LP Checked Permit', 'User checked the permits page');
    const history = useHistory();
    const { onSheet, onIonScroll } = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);
    const [loadingDocs, setLoadingDocs] = useState(true);

    const [showModalDoc, setShowModalDoc] = useState(false);
    const [doc, setDoc] = useState<DocumentInfo>();
    const [docs, setDocList] = useState<DocumentInfo[]>([]);
    const [selectedDocPages, setSelectedDocPages] = useState<number[]>([]);

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        ApiService.getDocsList('permit', {isLp: 0, type: 'permit'}).then(it => setDocList(it)).finally(() => setLoadingDocs(false));
    }, []);

    function prepDoc(nextDoc: any) {
        logUserAction('LP Permit Doc View', `User viewed a permit document: ${nextDoc.title}`);
        let tempArray: number[] = Array.from(Array(nextDoc.numPages).keys())
        setDoc(nextDoc);
        setSelectedDocPages(tempArray);
        setShowModalDoc(true);
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/docs');
    };

    const metaLine = loadingDocs ? 'Loading…' : `${docs.length} document${docs.length === 1 ? '' : 's'}`;

    return (
        <IonPage>
            <LoadDetailHeader title="Permits" onBack={goBack} onSheet={onSheet} />

            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
                <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                    <div className="home-hero safety-hero">
                        <div className="safety-hero__badge" aria-hidden="true">
                            <DocIcon color="#ffffff" size={28} />
                        </div>
                        <div className="safety-hero__eyebrow">Permit documents</div>
                        <div className="safety-hero__title home-display">Permits</div>
                        <div className="safety-hero__meta">{metaLine}</div>
                    </div>

                    <div className="home-sheet safety-sheet">
                        <section className="safety-section">
                            <h2 className="safety-section__title home-section-label">Documents</h2>
                            {docs.length === 0 && !loadingDocs ? (
                                <div className="scoreboard-empty">
                                    <strong>No documents</strong>
                                    <p>Permit documents will appear here when available.</p>
                                </div>
                            ) : null}
                            <div className="safety-doc-list">
                                {docs.map((item, index) => (
                                    <button
                                        key={item.id}
                                        type="button"
                                        className="safety-doc-row"
                                        style={{ ['--safety-delay' as string]: `${0.35 + index * 0.04}s` }}
                                        onClick={() => prepDoc(item)}
                                    >
                                        <span className="safety-doc-row__icon" aria-hidden="true">
                                            <FolderDocIcon size={18} />
                                        </span>
                                        <span className="safety-doc-row__label">{item.title}</span>
                                        <ChevronRight color="oklch(0.55 0.01 260)" />
                                    </button>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>
            </IonContent>

            <IonModal isOpen={showModalDoc} cssClass="safety-viewer-modal" onDidDismiss={() => setShowModalDoc(false)}>
                <div className="safety-media-modal">
                    <div className="safety-media-modal__header">
                        <button type="button" className="safety-media-modal__back" onClick={() => setShowModalDoc(false)}>
                            <ChevronLeft size={20} />
                            Back
                        </button>
                        {doc?.title ? <div className="safety-media-modal__title">{doc.title}</div> : null}
                    </div>
                    <div className="safety-media-modal__body safety-media-modal__body--doc">
                        <TransformWrapper initialScale={1} minScale={1} maxScale={4} centerOnInit key={selectedDocPages.length}>
                            <TransformComponent
                                wrapperStyle={{ width: '100%', height: '100%' }}
                                contentStyle={{ width: '100%', height: '100%' }}
                            >
                                <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                                    {selectedDocPages.map(function(page: number) {
                                        return (
                                            <img
                                                key={page}
                                                className="safety-media-modal__page"
                                                src={'https://westernexpressmobile.com/docs2/' + doc?.type + '_' + doc?.id + '_' + page + '.' + doc?.extension}
                                                alt={'Page ' + page}
                                            />
                                        );
                                    })}
                                </div>
                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            </IonModal>
        </IonPage>
    );
};

export default Permits;
